<template>
    <div class="row">
        <div class="col-sm-12">
            <form @submit.prevent="validateBeforeSubmit">
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="name">{{ $t('global.name') }}</label>
                        <div class="col-sm-5">
                            <input :class="{'form-control':true, 'is-valid':validError, 'is-invalid':invalidError }"
                                   id="name" name="name"
                                   type="text"
                                   v-model="form.name" v-validate="'required'">

                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('name')"/>
                                <span v-show="errors.has('name')">{{ errors.first('name') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="surname">{{
                            $t('hotelsmanagehotelinformation.surname') }}</label>
                        <div class="col-sm-5">
                            <input :class="{'form-control':true, 'is-valid':validError, 'is-invalid':invalidError }"
                                   id="surname" name="surname"
                                   type="text"
                                   v-model="form.surname" v-validate="'required'">

                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('surname')"/>
                                <span v-show="errors.has('surname')">{{ errors.first('surname') }}</span>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="lastname">{{
                            $t('hotelsmanagehotelinformation.lastname') }}</label>
                        <div class="col-sm-5">
                            <input :class="{'form-control':true, 'is-valid':validError, 'is-invalid':invalidError }"
                                   id="lastname" name="lastname"
                                   type="text"
                                   v-model="form.lastname" v-validate="'required'">

                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('lastname')"/>
                                <span v-show="errors.has('lastname')">{{ errors.first('lastname') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="email">{{ $t('hotelsmanagehotelinformation.email')
                            }}</label>
                        <div class="col-sm-5">
                            <input :class="{'form-control':true, 'is-valid':validError, 'is-invalid':invalidError }"
                                   data-vv-as="email" id="email"
                                   name="email" @change="removeAccents()"
                                   type="text" v-model="form.email" v-validate="'required|email'">
                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('email')"/>
                                <span v-show="errors.has('email')">{{ errors.first('email') }}</span>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="position">{{
                            $t('hotelsmanagehotelinformation.position') }}</label>
                        <div class="col-sm-5">
                            <input :class="{'form-control':true, 'is-valid':validError, 'is-invalid':invalidError }"
                                   id="position" name="position"
                                   type="text"
                                   v-model="form.position" v-validate="'required'">

                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('position')"/>
                                <span v-show="errors.has('position')">{{ errors.first('position') }}</span>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-2 col-form-label" for="contact_type_id">{{
                            $t('hotelsmanagehotelinformation.contact_type') }}</label>
                        <div class="col-sm-5">
                            <select :class="{'form-control':true, 'is-invalid':errors.has('contact_type_id') }"
                                    id="contact_type_id" name="contact_type_id"
                                    v-model="form.contact_type_id" v-validate="'required'">
                                <option :value="null">{{ $t('hotelsmanagehotelinformation.select_contact_type') }}</option>
                                <option :key="type.id" :value="type.id"
                                        v-for="type in contactTypes">{{ type.name }}</option>
                            </select>

                            <div class="bg-danger" style="margin-top: 3px;border-radius: 2px;">
                                <font-awesome-icon :icon="['fas', 'exclamation-circle']"
                                                   style="margin-left: 5px;" v-show="errors.has('contact_type_id')"/>
                                <span v-show="errors.has('contact_type_id')">{{ errors.first('contact_type_id') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-4 col-form-label">{{ $t('hotelsmanagehotelinformation.principal')
                            }}</label>
                        <div class="col-sm-2 mt-1">
                            <c-switch id="principal" class="mx-1" color="primary"
                                      v-model="form.principal"
                                      variant="pill">
                            </c-switch>
                        </div>
                    </div>
                </div>
                <div class="b-form-group form-group">
                    <div class="form-row">
                        <label class="col-sm-4 col-form-label">{{ $t('global.status') }}</label>
                        <div class="col-sm-2 mt-1">
                            <c-switch class="mx-1" color="primary"
                                      v-model="form.status"
                                      variant="pill">
                            </c-switch>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-sm-6">
            <div slot="footer">
                <img src="/images/loading.svg" v-if="loading" width="40px"/>
                <button @click="validateBeforeSubmit" class="btn btn-success" type="submit" v-if="!loading">
                    <font-awesome-icon :icon="['fas', 'dot-circle']"/>
                    {{$t('global.buttons.save')}}
                </button>
                <button @click="close" class="btn btn-danger" type="reset" v-if="!loading">
                    {{$t('global.buttons.cancel')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  import { API } from './../../../../api'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import { Switch as cSwitch } from '@coreui/vue'

  export default {
    props: ['form'],
    components: {
      VueBootstrapTypeahead,
      cSwitch
    },
    data: () => {
      return {
        languages: [],
        contact: null,
        contactTypes: [],
        hotels: [],
        hotel: null,
        hotelSearch: '',
        showError: false,
        currentLang: '1',
        invalidError: false,
        countError: 0,
        loading: false
      }
    },
    computed: {
      errorHotel: function () {
        if (this.form.hotel_id == null) {
          return false
        }

      },
      validError: function () {
        if (this.errors.has('name') === false && this.form.name !== '') {
          this.invalidError = false
          this.countError += 1
          return true

        } else if (this.countError > 0) {
          this.invalidError = true
        }
        return false
      }
    },
    mounted: function () {
         //hotels
          API.get('/hotel/selectbox?lang=' + localStorage.getItem('lang'))
            .then((result) => {
              this.hotels = result.data.data
            }).catch(() => {
            this.$notify({
              group: 'main',
              type: 'error',
              title: this.$t('hotelsmanagehotelinformation.error.messages.name'),
              text: this.$t('hotelsmanagehotelinformation.error.messages.connection_error')
            })
          })

          //contact types
          API.get('contacts/types')
            .then((result) => {
              if (result.data.success === true) {
                this.contactTypes = result.data.data
              }
            }).catch(() => {
            this.$notify({
              group: 'main',
              type: 'error',
              title: this.$t('hotelsmanagehotelinformation.error.messages.name'),
              text: this.$t('hotelsmanagehotelinformation.error.messages.connection_error')
            })
          })
    },
    methods: {
        removeAccents(){
            this.form.email = this.form.email.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
      close () {
        this.$emit('changeStatus', false)
      },
      validateBeforeSubmit () {
        this.$validator.validateAll().then((result) => {
          if (result) {

            this.submit()

          } else {
            this.$notify({
              group: 'main',
              type: 'error',
              title: this.$t('global.modules.contacts'),
              text: this.$t('hotelsmanagehotelinformation.error.messages.information_complete')
            })

            this.loading = false
          }
        })
      },
      submit () {

        this.loading = true

        API({
          method: this.form.action,
          url: 'contacts/' + (this.form.id !== null ? this.form.id : ''),
          data: this.form
        })
          .then((result) => {
            if (result.data.success === false) {

              this.$notify({
                group: 'main',
                type: 'error',
                title: this.$t('global.modules.contacts'),
                text: this.$t('hotelsmanagehotelinformation.error.messages.contact_incorrect')
              })

              this.loading = false
            } else {
              this.close()
            }
          }).catch((e) => {
          this.$notify({
            group: 'main',
            type: 'error',
            title: this.$t('hotelsmanagehotelinformation.error.messages.name'),
            text: this.$t('hotelsmanagehotelinformation.error.messages.connection_error')
          })
        })
      }
    }
  }
</script>

<style lang="stylus">

</style>
